
import { defineComponent, computed } from 'vue'
import { Button } from 'vant'

export default defineComponent({
  name: 'MobileCard',
  components: { 'van-button': Button },
  props: {
    title: { type: String, default: '' },
    moreText: { type: String, default: '' },
    moreLink: { type: String, default: '' },
    fullview: { type: [Boolean, String], default: false }
  },
  emits: ['moreClick'],
  setup(props, { emit }) {
    function emitMoreClick() {
      emit('moreClick')
    }
    const showFullView = computed(() => (props.fullview === '' ? true : !!props.fullview))
    return {
      emitMoreClick,
      showFullView
    }
  }
})
